<li
  class="header-menu-item"
  [class.header-menu-item--root]="root"
  [class.active]="active"
  [class.has-items]="!root && menuItem.items?.length > 0"
  [class.has-submenu]="rootHasSubMenu()"
  [class.featured]="menuItem.featured"
>
  <a
    *ngIf="root && menuItem.link && (!menuItem.items || menuItem.items?.length === 0)"
    class="header-menu-item__root--link"
    [href]="menuItem.link"
  >
    {{ menuItem.label }}
  </a>
  <button
    *ngIf="root && !menuItem.link && menuItem.items?.length > 0"
    class="header-menu-item__root--cta"
    [class.active]="active"
    (click)="toggle()"
  >
    {{ menuItem.label }}
  </button>

  <div class="header-menu-item__content" [class.active]="!root || active">
    <div
      class="header-menu-item__content-wrapper"
      [class.has-items]="!root && menuItem.items?.length > 0"
    >
      <p
        *ngIf="!root && !menuItem.link && !menuItem.action"
        class="header-menu-item__label"
        [class.has-items]="!root && menuItem.items?.length > 0"
      >
        {{ menuItem.label }}
      </p>

      <p
        *ngIf="menuItem.topLabel"
        class="header-menu-item__label header-menu-item__label--top has-items"
      >
        {{ menuItem.topLabel }}
      </p>

      <a
        *ngIf="!root && menuItem.link"
        class="header-menu-item__link"
        [class.has-items]="!root && menuItem.items?.length > 0"
        [href]="menuItem.link"
      >
        <img
          *ngIf="menuItem.iconSrc"
          class="header-menu-item__icon"
          [src]="menuItem.iconSrc"
          [alt]="menuItem.label"
          width="40"
        />
        <p class="header-menu-item__link-label">
          {{ menuItem.label }}
          <ng-container *ngIf="menuItem.caption">
            <br />
            <span class="header-menu-item__link-caption">{{ menuItem.caption }}</span>
          </ng-container>
        </p>
      </a>

      <button
        *ngIf="!root && menuItem.action"
        class="header-menu-item__cta"
        [class.has-items]="!root && menuItem.items?.length > 0"
        (click)="menuItem.action()"
      >
        {{ menuItem.label }}
      </button>

      <ul *ngIf="menuItem.items?.length > 0" class="header-menu-item__list" [class.active]="active">
        <header-menu-item
          *ngFor="let item of menuItem.items"
          [menuItem]="item"
          [root]="false"
        ></header-menu-item>
      </ul>
    </div>
  </div>
</li>
